function sendMessage(type, data) {
    if (!("serviceWorker" in navigator)) {
        return Promise.reject(new Error("Service worker not supported"));
    }
    return new Promise(function(resolve, reject) {
        const messageChannel = new MessageChannel();
        messageChannel.port1.onmessage = event => {
            if (event.data.error) {
                reject(event.data.error);
            } else {
                resolve(event.data);
            }
        };
        if (navigator.serviceWorker.controller) {
            navigator.serviceWorker.controller.postMessage({ type, data }, [messageChannel.port2]);
        } else {
            reject(new Error("No navigator.serviceWorker.controller"));
        }
    });
}

export default {
    sendMessage
};
